<template>
  <div class="editActive">
    <div class="flex space-between pl10 pr20">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>活动/新增活动</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <el-row>
      <el-col :span="18" :offset="2">
        <el-form style="margin-top: 30px;" :model="form" :rules="rules" ref="activeForm" label-position="right" size="small" label-width="200px">
          <template v-for="(item,ind) in form.list">
            <template v-if="item.fieldKey != 'atyDate' && item.fieldKey != 'atyBTime' && item.fieldKey != 'atyETime' && item.fieldKey != 'atyQuota' && item.fieldKey != 'atyPrice' && item.fieldKey != 'atyLogo'">
              <el-form-item :label="item.fieldName" :key="ind" :prop="item.fieldKey" :rules="rulesFn(item)">
                <el-input  :type=" ( item.fieldKey == 'atyContent' ||  item.fieldKey == 'atyEContent' ) ? 'textarea': 'text'"  v-model.trim="form[item.fieldKey]" :placeholder='"请输入"+item.fieldName'></el-input>
              </el-form-item>
            </template>
            <!-- 会议图片 -->
            <template v-if="item.fieldKey == 'atyLogo'">
              <el-form-item :label="item.fieldName" :key="ind" :prop="item.fieldKey" :rules="rulesFn(item)">
                <Upload :isFaceRead="false" :mediaUrl.sync="form[item.fieldKey]" :typeString = '"A"' />
                <el-input v-model="form[item.fieldKey]" style="display:none;"></el-input>
              </el-form-item>
            </template>
            <!-- 会议人数 会议费用 -->
            <template v-if="item.fieldKey == 'atyQuota' || item.fieldKey == 'atyPrice' ">
              <el-form-item :label="item.fieldName" :key="ind" :prop="item.fieldKey" :rules="rulesFn(item)">
                <el-input   v-model.trim="form[item.fieldKey]" @keyup.native="inputChange($event,item.fieldKey)" :placeholder='"请输入"+item.fieldName'></el-input>
              </el-form-item>
            </template>

            <template v-if="item.fieldKey == 'atyDate'">
              <el-form-item :label="item.fieldName" :prop="item.fieldKey" :key="ind" :rules="rulesFn(item)">
                <el-date-picker @change="changeDate" v-model="form[item.fieldKey]" type="date" placeholder="选择会议日期"></el-date-picker>
              </el-form-item>
            </template>
            <template v-if="item.fieldKey == 'atyBTime'">
              <el-form-item :label="item.fieldName" :prop="item.fieldKey" :key="ind" :rules="rulesFn(item)">
                <el-time-select  placeholder="起始时间" v-model="form[item.fieldKey]" :picker-options="{ start: '08:30', step: '00:15', end: '18:30'}">
                </el-time-select>
              </el-form-item>
            </template>

            <template v-if="item.fieldKey == 'atyETime'">
              <el-form-item :label="item.fieldName" :prop="item.fieldKey" :key="ind" :rules="rulesFn(item)">
                <el-time-select placeholder="结束时间" v-model="form[item.fieldKey]" :picker-options="{ start: '08:30', step: '00:15', end: '18:30', minTime:form.atyBTime }"></el-time-select>
              </el-form-item>
            </template>
          </template>
        </el-form>
        <div class="btns noborder">
          <el-button size="medium" type="primary" :style="buttonStyle" @click="onSubmit">提交</el-button>
          <el-button size="medium" @click="back">返回</el-button>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import api from '@/api'
import Upload from '@/components/Upload'
import tools from '@/utils/tools';
import { validateAddress } from '@/utils/validator'
export default {
  
  components: {
    Upload
  },
  data () {
    return {
      "id": `${this.$route.query.id}` === 'undefined' ? '' : `${this.$route.query.id}`,
      saveBtnStatue:false,  //保存铵钮状态
      form: {
        list: []
      },
      classTypeList:[],
      rules: {
      },
      isShowCalendar: false,
      buttonStyle: sessionStorage.getItem('buttonStyle') ? JSON.parse(sessionStorage.getItem('buttonStyle')) : {}
    }
  },
  mounted() {
    this.getField()
  },

  methods: {
    //禁止input输入 数字以外的字符
    inputChange(ev,val){
      this.form[val] = this.form[val].replace(/[^\d]/g,'');
    },
    changeDate() {
      this.form.atyDate =  tools.formatDate(this.form.atyDate, 'yyyy-MM-dd')
    },
    validateProvince (rule, value, callback) {
      if (this.form.alyCountry) {
        if (this.form.alyCountry === '中国') {
          if (!value) {
            callback(new Error('请选择省份'))
          } else {
            callback()
          }
        } else {
          callback()
        }
      } else {
        callback()
      }
    },
    validateCity (rule, value, callback) {
      if (this.form.alyCountry) {
        if (this.form.alyCountry === '中国') {
          if (this.form.alyProvince) {
            if (!value) {
              callback(new Error('请选择城市'))
            } else {
              callback()
            }
          } else {
            callback()
          }
        } else {
          callback()
        }
      } else {
        callback()
      }
    },
    rulesFn(item){
      var temp = ''
      var rulesData= {
        atyLogo: [{ required: item.required, trigger: 'change', message: '请上传'+item.fieldName}],
        atyPlace: [{ required: item.required, trigger: 'blur', message: item.fieldName+"请输入6-100个字符", validator: validateAddress}],
        atyEPlace: [{ required: item.required, trigger: 'blur', message: item.fieldName+"请输入6-100个字符", validator: validateAddress}],
        other:{required:item.required, message: item.fieldName+'不能为空', trigger: 'blur'},
      }
      switch (item.fieldKey){
      case 'atyLogo':
      case 'atyPlace':
      case 'atyEPlace':
        temp = item.fieldKey
        break;
      default: 
        temp = 'other'
        break
      }
      return rulesData[temp]
    },
    async getField() {
      await api.getsaasfield({type: 'meet'}).then(res => {
        if (res.data.code === 200) {
          this.form.list =[]
          for(var i = 0;i<res.data.data.length;i++){
            if(res.data.data[i].enable == 1){
              this.form.list.push(res.data.data[i])
            }
          }
          for(var j=0;j<this.form.list.length;j++){
            this.$set( this.form,this.form.list[j].fieldKey,'')
          }
          if (this.id !='') { // 修改
            api.getactivitydetail({atyID : parseInt(this.id) }).then((res)=>{
              if(res.data.code =='200'){
                var _data = res.data.data
                for (let i in res.data.data) {
                  this.form[i] = res.data.data[i]
                } 
                this.form.atyID = res.data.data.atyID
              }
            })
          }
        }
      })
    },
    confirmCalendar(data) {
      this.form.atyDate = data
    },
    showCalendar() {
      this.isShowCalendar = true
    },
    onSubmit() {
      if( this.saveBtnStatue ){
          return false
      }
      this.$refs['activeForm'].validate((valid) => {
        if (valid) {
          var paramt = JSON.parse(JSON.stringify(this.form))
          if(this.atyID !=''){
            paramt.atyID = parseInt( this.id)
          }
          paramt.atyDate = tools.formatDate(paramt.atyDate ,'yyyy-MM-dd hh:mm:ss') 
          paramt.atyID = parseInt(this.form.atyID)
          let tmpObj = {}
          for(let i in paramt){
            if (i === 'atyPrice' || i === 'atyQuota') {
              tmpObj[i] = Number(paramt[i])
            } else if (i === 'atyID') {
              if (!paramt[i]) {
                tmpObj[i] = 0
              } else {
                tmpObj[i] = Number(this.id)
              }
            } else {
              tmpObj[i] = paramt[i]
            }
          }
          this.saveBtnStatue = true
          api.saveactivity(tmpObj).then((res) => {
            if (res.data.code === 200) {
                this.$notify({
                  title: '保存成功',
                  type: 'success'
                })
                this.$router.go(-1)
            }
            this.saveBtnStatue = false
          })
        } else {
          this.$notify({
            title: '请检查表单填写项是否符合规范！',
            type: 'error'
          })
          return false
        }
      })
    },
    back() {
      this.$router.go(-1)
    }
  }
}
</script>
<style lang="less">
.editActive{
  .blue {
    color: #409eff;
  }

  .title {
    margin-bottom: 30px;
  }

  .col-1-fix {
    padding-left: 0 !important;
  }
  .desc{
    font-size: 14px;
    line-height: 18px;
    padding: 10px;
  }
  .mz{
    font-size:14px;
    color:#999;
  }
  .btns{
    text-align: center;
    padding-top: 15px;
  }
  @media screen and (max-width:540px){
    .minput{
      height: 32px;
      line-height: 32px;
      text-align: right;
      font-size: 14px;
      color:#606266;
      border:0;
      width: 98%;
    }
    .dash-upload{
      width:160px;
    }
    .el-input__inner{
      border:0;
      text-align: right;
    }
    .el-form-item{
      border-bottom:1px solid #DCDFE6;
    }
    .noborder{
      border:0;
    }
    .el-form-item--small .el-form-item__error{
      text-align: right;
      width: 100%;
    }
  }
}
</style>
